import { IDLE_VERYLOW_PRIORITY, IMMEDIATE_PRIORITY, } from '@office-start/scheduler-service';
export var getSchedulingPriorityForAppBar = function (pathname) {
    return (pathname === null || pathname === void 0 ? void 0 : pathname.includes('/chat')) || (pathname === null || pathname === void 0 ? void 0 : pathname.includes('/copilot'))
        ? IDLE_VERYLOW_PRIORITY
        : IMMEDIATE_PRIORITY;
};
//# sourceMappingURL=appBarUtils.js.map